import { getStandardizeDateTimeFormat } from "./util";

// promo
function registerPromo(promoId, callBack) {
  api.registerPromo(promoId, callBack);
}

$(function () {
  api.getPromo(function (response) {
    if (response) {
      var promoData = response.data.result;
      var promoWrapper = $(`<div class="promo-list-wrapper"></div>`);
      var promoDetailWrapper = $(`<div class="promo-detail-wrapper"></div>`);

      promoData.forEach(function (value, index) {
        var promoId = value.promoId;
        var promoItem = $(
          `<div class="promo-item" data-active-category='${value.activeCategory}' data-type="${value.type}" data-promoid="${promoId}"></div>`
        );

        const startDate = new Date(value.created);
        const processedStartDate = startDate.toISOString().split("T")[0];

        const endDate = value?.endDate ? new Date(value.endDate) : undefined;
        const processedEndDate = endDate ? endDate.toISOString().split("T")[0] : undefined;

        if (index === 0) {
          $(".modal-container__promo-detail > h5").text(value.title);
        }

        promoItem.append(`
          <div class="promo-item__header"> 
            <div>
              <img src="img/icon-promo.svg"/> 
              <p>${value.displayName}</p>
            </div>
            <p>${processedStartDate} ${processedEndDate ? `至 ${processedEndDate}` : ""}</p>
          </div>
          <div class="promo-item__content">
            ${
              value?.imagePath
                ? `
                    <div>
                      <img src="${value.imagePath}" alt="${value.title}" loading="lazy" />
                      <p class="hide">${value.title}</p>
                    </div>
                  `
                : `
                    <div>
                      <p>${value.title}</p>
                    </div>
                  `
            }
          </div>
        `);

        promoWrapper.append(promoItem);

        var requestToJoin = value.requestToJoin;
        var firstDepositPromoJoinMsg = value.firstDepositPromoJoinMsg;

        var promoDetailItem = $(
          `<div class="promo-detail-item ${index === 0 ? "" : "hide"}" data-promoid="${promoId}"></div>`
        );
        promoDetailItem.append(`
        ${value.content}
        ${
          requestToJoin
            ? `
                 <div
                   class="item-footer"
                   style="display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; height: 50px;font-size: 14px"
                 >
                   ${
                     firstDepositPromoJoinMsg
                       ? `
                         <div class="item-footer--info" style="color: #555;">
                           ${firstDepositPromoJoinMsg}
                         </div>
                       `
                       : `
                         <button
                           class="btn primary item-footer--register-promo"
                           data-id="${promoId}"
                         >
                           申请参与
                         </button>
                       `
                   }
                 </div>
               `
            : ``
        }`);

        promoDetailWrapper.append(promoDetailItem);

        promoItem.on("click", function () {
          const promoId = $(this).attr("data-promoid");
          $(".modal-container__promo-detail > h5").text(value.title);
          $(".promo-detail-container")
            .find(`.promo-detail-item[data-promoid="${promoId}"]`)
            .removeClass("hide")
            .siblings()
            .addClass("hide");
        });
      });

      $("#modal-promo .modal-container .modal-container__promo-list .promo-list-container").html(promoWrapper);
      $("#modal-promo .modal-container .modal-container__promo-detail .promo-detail-container").html(
        promoDetailWrapper
      );

      $(".promo-item__content img").on("error", function () {
        $(this).addClass("hide");
        $(this).siblings().removeClass("hide");
      });
    }

    $(document).on("click", ".item-footer--register-promo", function (e) {
      e.preventDefault();
      var promoId = $(this).data("id");
      registerPromo(promoId, () => {});
    });
  });
});

$(".promo-nav .promo-nav__nav-item").on("click", function () {
  $(this).addClass("active").siblings().removeClass("active");
  const currentActiveCategory = $(this).attr("data-category");

  if (currentActiveCategory !== "-1") {
    $(".promo-list-wrapper")
      .find(".promo-item")
      .each(function () {
        const itemActiveCategory = $(this).attr("data-active-category");
        const regex = new RegExp(`\\b${currentActiveCategory}\\b`);

        if (regex.test(itemActiveCategory)) {
          $(this).removeClass("hide");
        } else {
          $(this).addClass("hide");
        }
      });
  } else {
    $(".promo-list-wrapper").children().removeClass("hide");
  }

  $(".promo-list-wrapper").parent().scrollTop(0);
  $(".promo-list-wrapper").find(".promo-item").not(".hide").first().trigger("click");
});

$(function () {
  $(".section-content.section-promo .switchable .nav .tab").click(function () {
    var index = $(this).index();
    var dataType = $(this).find("a").data("type");

    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    if (dataType === -1) {
      $(".item").slideDown();
    } else {
      $('.item[data-type="' + dataType + '"]').slideDown();
      $('.item:not([data-type="' + dataType + '"])').slideUp();
    }

    loadPromoAnimation();
  });

  $(".section-faq .tab-wrapper ul li").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    location.hash = $(this).attr("data-hash");
    let currTab = location.hash.slice(1);
    const origin = window.location.origin;

    $(`.tab-content[data-hash="${currTab}"]`).addClass("active").siblings().removeClass("active");

    //set to 1st subtab on main tab change
    if (currTab === "novice") {
      $(`.subtab-wrapper ul li[data-hash="recharge-desktop"]`).addClass("active").siblings().removeClass("active");
      $(`.subtab-content[data-hash="recharge-desktop"]`).addClass("active").siblings().removeClass("active");
    } else if (currTab === "faq") {
      $(`.subtab-wrapper ul li[data-hash="faq-recharge"]`).addClass("active").siblings().removeClass("active");
      $(`.subtab-content[data-hash="faq-recharge"]`).addClass("active").siblings().removeClass("active");

      //set iframe for 1st subtab if is in FAQ tab
      const iframe = $(".subtab-content[data-hash='faq-recharge'] iframe");
      if (!iframe[0].getAttribute("src")) {
        iframe[0].setAttribute("src", `${origin}/util/faq/dsn/faq-recharge.html`);
      }
    }
  });

  $(".section-faq .tab-content ul li").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    location.hash = $(this).attr("data-hash");
    let currTab = location.hash.slice(1);

    $(`.subtab-content[data-hash="${currTab}"]`).addClass("active").siblings().removeClass("active");

    const origin = window.location.origin;

    let curriFrame = $(`.subtab-content[data-hash="${currTab}"] iframe`);

    if (!curriFrame[0].getAttribute("src")) {
      curriFrame[0].setAttribute("src", `${origin}/util/faq/dsn/${currTab}.html`);
    }
  });
});

// show random games
var gameIdList = [
  "CQSSC",
  "SSCJSC",
  "TJSSC",
  "XJSSC",
  "11x5jsc",
  "AULUCKY10",
  "AULUCKY20",
  "AULUCKY5",
  "AULUCKY8",
  "KL8JSC",
  "BJPK10",
  "BJPK10BJL",
  "F3D",
  "GD11X5",
  "GXK3",
  "GXKLSF",
  "HK6",
  "HK6JSC",
  "K3JSC",
  "KL8JSC",
  "KLSFJSC",
  "JLK3",
  "LUCKYSB",
  "PCEGG",
  "PK10JSC",
  "PL3",
  // "TXFFC",
  "XYNC",
  "PK10JSCNN_A",
  "PK10JSCNN",
  "GDKLSF",
];

function randomGames() {
  gameIdList.sort((a, b) => {
    return Math.random() < 0.5 ? 1 : -1;
  });
  $(".section-spray-spots .game").each(function (i, elem) {
    elem.className = `game game-${gameIdList[i]}`;
  });
}

function changeSpots() {
  var state = $(".section-spray-spots").hasClass("active");
  if (state) {
    $(".section-spray-spots").addClass("hide");
    setTimeout(randomGames, 500);
    setTimeout(function () {
      $(".section-spray-spots").removeClass("hide");
    }, 1000);
  }
}

window.setInterval(changeSpots, 10000);

// promo page

$(function () {
  $(document).on("click", ".item > .item-head", function () {
    $(this).next().stop().slideToggle();
  });
});

function loadPromoAnimation() {
  if ($(".section-content.section-promo").length !== 0) {
    $(".section-content.section-promo .page .item").each(function (k, i) {
      $(i).removeClass("ready");
      setTimeout(function () {
        $(i).addClass("ready");
      }, (k + 1) * 150);
    });
  }
}

// app page
$(function () {
  var spots = ["#f8b615", "#88ceda", "#ffffff", "#8c5fa5"];

  const hexToRgb = function (hex, alpha) {
    const rgb = hex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
      .substring(1)
      .match(/.{2}/g)
      .map((x) => parseInt(x, 16));
    return alpha ? `rgba(${rgb[0]},${rgb[1]},${rgb[2]}, ${alpha})` : `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`;
  };

  if ($("[data-sweet]").length !== 0) {
    $("[data-sweet]").each(function (i, elem) {
      var amount = $(elem).attr("data-sweet") || 14;
      spraySpots($(elem), amount);
    });
  }

  function spraySpots(elem, amount) {
    var spotArea = $('<div class="spot-area"></div>').css("width", "100%").css("height", "100%");

    for (var i = 0; i < amount; i++) {
      var size = Math.random() * 5 + 1;
      var color = spots[Math.floor(Math.random() * spots.length)];
      var posX = Math.random() * 20;
      var posY = Math.random() * 100;
      var side = i % 2 == 0 ? "left" : "right";
      var spot = $('<div class="spot"></div>')
        .css("width", size + "em")
        .css("height", size + "em")
        .css("opacity", "0.5")
        .css("borderRadius", "50%")
        .css("border", "1px solid " + color)
        .css("backgroundColor", hexToRgb(color, 0.6))
        .css("position", "absolute")
        .css(side, posX + "%")
        .css("top", posY + "%")
        .css("transition", "all 500ms ease")
        .css("transitionDelay", i * 40 + "ms")
        .css("animationDelay", i * -400 + "ms")
        .css("will-change", "transform opacity")
        .addClass(side);
      spotArea.append(spot);
    }
    elem.append(spotArea);
  }

  function atomAffect(elem) {
    var tracks = 4;
    var dotSeq = 0;
    var dotsPool = [];
    var tracksPool = [];
    elem
      .css("width", "35rem")
      .css("height", "35rem")
      .css("position", "absolute")
      .css("right", "-2rem")
      .css("top", "5rem");

    for (var i = 0; i < tracks; i++) {
      var track = $('<div class="track"></div>');
      var diameter = 4 + 6 * i * Math.pow(1.2, i);
      var dotAmount = Math.floor((diameter * Math.PI) / 7);
      tracksPool.push({
        seq: i,
        radius: diameter / 2,
        elem: track,
      });
      track
        .attr("data-track-seq", i)
        .css("position", "absolute")
        .css("left", "50%")
        .css("top", "50%")
        .css("borderRadius", "50%")
        .css("transform", "translate(-50%, -50%)")
        .css("width", "calc(" + diameter + "rem + 4px)")
        .css("height", "calc(" + diameter + "rem + 4px)")
        .css("boxSizing", "border-box")
        .css("borderWidth", "4px")
        .css("borderStyle", "solid");
      elem.append(track);

      function Dot(seq, radius, angle, elem) {
        this.seq = seq;
        this.radius = radius;
        this.angle = angle;
        this.elem = elem;
      }
      Dot.prototype.update = function () {
        var posX = this.radius * Math.cos(this.angle);
        var posY = this.radius * Math.sin(this.angle);
        $(this.elem).css("transform", "translate( calc(" + posX + "rem - 50%),calc(" + posY + "rem - 50%)");
      };

      for (var j = 0; j < dotAmount; j++) {
        var dot = $('<div class="dot"></div>');
        var angle = ((Math.PI * 2) / dotAmount) * j + Math.PI * (0.9 + i * -0.3);
        var posX = (diameter / 2) * Math.cos(angle);
        var posY = (diameter / 2) * Math.sin(angle);
        dotSeq++;
        dotsPool.push(new Dot(dotSeq, diameter / 2, angle, dot));

        dot
          .attr("data-dot-seq", dotSeq)
          .attr("data-radius", diameter / 2)
          .attr("data-angle", angle)
          .css("position", "absolute")
          .css("left", "calc(50% + " + posX + "rem - 0.5rem")
          .css("top", "calc(50% + " + posY + "rem - 0.5rem")
          .css("borderRadius", "50%")
          .css("transform", "-50% -50%");
        // .css("transform", "translate( calc(" + posX + "rem - 50%),calc(" + posY + "rem - 50%)");
        elem.append(dot);
      }
    }

    var radarRadius = 0;
    var timeRec = 0;
    var radarRadiusMax = 50;
    function dotAnimate() {
      timeRec++;
      if (timeRec % 2 == 0) {
        // skip frames
        if (radarRadius < radarRadiusMax) {
          radarRadius += 0.5;
        } else {
          radarRadius = 0;
        }
        dotsPool.forEach(function (item, i) {
          // console.log(radarRadius, item.elem);
          // item.angle = item.angle + Math.PI / 200 / item.radius;
          // item.update();
          if (Number(item.radius) >= radarRadius - 2 && Number(item.radius) <= radarRadius + 2) {
            $(item.elem).addClass("active");
          } else {
            $(item.elem).removeClass("active");
          }
        });

        tracksPool.forEach(function (item, i) {
          if (Number(item.radius) >= radarRadius && Number(item.radius) <= radarRadius + 10) {
            $(item.elem).addClass("active");
          } else {
            $(item.elem).removeClass("active");
          }
        });
      }
      window.requestAnimationFrame(dotAnimate);
    }

    window.requestAnimationFrame(dotAnimate);
  }

  atomAffect($("#atom"));
});

const chineseDateFormat = new Intl.DateTimeFormat("zh", { month: "long", day: "numeric" });

// information slide
$(function () {
  var announcementContainer = $("#announcementContainer");
  announcementContainer.children().remove();

  var announcementList = $(".modal-container__announcement-list .announcement-list-wrapper");
  announcementList.children().remove("div");

  if (!!announcementContainer.length) {
    api.getNotice(function (response) {
      response.data.result.forEach(function (info, i) {
        const { text, title, id, created, category } = info || {};

        announcementContainer.append(
          $(`<div data-id=${id} class="info${i == 0 ? " active" : ""}">${text}</div>`)
        );

        announcementList.append(
          `
            <div data-id='${id}' data-date='${getStandardizeDateTimeFormat(created, true)}'>
              <img src="img/icon-list-announcement.svg">
              <p>${category}</p>
              <span>${getStandardizeDateTimeFormat(created, true)}</span>
            </div>
          `
        );

        window.notices = { ...window.notices, [id]: { text, title } };
      });

      announcementList.children("div").on("click", function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        const currentInfoDate = $(this).data("date");
        const { text, title } = window.notices[$(this).data("id")] || {};

        var announcementDetail = $(".modal-container__announcement-detail");
        announcementDetail.children().remove();
        announcementDetail.append(
          `
            <span>${currentInfoDate}</span>
            <span class="announcement-title">${title}</span>
            <p>${text}</p>
          `
        );
      });
    });

    announcementContainer.on("click", function () {
      $("#modal-announcement").addClass("active");

      const selectedAnnouncement = $(this).children(".active").data("id");
      $(".modal-container__announcement-list .announcement-list-wrapper").children(`div[data-id='${selectedAnnouncement}']`).trigger("click");
    });
  }

  var transactionsContainer = $("#transactionsContainer");
  transactionsContainer.children().remove();
  if (!!transactionsContainer.length) {
    api.getTrans(function (response) {
      response.data.result.forEach(function (info, i) {
        // console.log(info);
        transactionsContainer.append(
          $(
            `<div class="info${i == 0 ? " active" : ""}">
              恭喜会员 ${info.username} 提款 ${-info.amount} 元成功，请及时查看银行卡账目。
            </div>`
          )
        );
      });
    });
  }
});

// banner2

$(function () {
  var banner2Width = $(".banner2").width();
  var banner2Height = $(".banner2").height();
  $(".banner2 .img, .banner2 .spot").each(function (i, item) {
    var posXoffset = -(item.offsetLeft + $(item).width() / 2) + banner2Width / 2;
    var posYoffset = -(item.offsetTop + $(item).height() / 2) + banner2Height * 0.8;
    $(item).css("transform", `translate(${posXoffset * 0.8}px, ${posYoffset * 0.8}px)`);
  });
});

// hash detection
$(function () {
  function detectHash() {
    var currentHash = location.hash.slice(1);
    $("[data-hash='" + currentHash + "']")
      .addClass("active")
      .siblings()
      .removeClass("active");
  }

  detectHash();
  $(".tab[data-hash]").click(function (event) {
    event.preventDefault();
    location.hash = $(this).attr("data-hash");
  });

  $('[href*="html#"]').click(function () {
    setTimeout(detectHash, 10);
    $(window).scrollTop(0);
  });
});

// Announcement Animation
if ($(".info-wrapper").length) {
  $(".info-wrapper").each((item, element) => {
    var intervalId = null;
    intervalId = window.setInterval(nextInfo, 2000);
    $(element).on("mouseenter", function () {
      window.clearInterval(intervalId);
    });
    $(element).on("mouseleave", function () {
      intervalId = window.setInterval(nextInfo, 2000);
    });

    function nextInfo() {
      var currentActive = $(element).find(".info.active");
      currentActive.removeClass("active");
      if (currentActive.next().length) {
        currentActive.next().addClass("active");
      } else {
        $(element).find(".info").eq(0).addClass("active");
      }
    }
  });
}
